import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import { WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import { DEFAULT_LANGUAGE } from '../../../../config/constants';

import { Button } from '../../../../components';

import './style.scss';

const NodeMunicipality = ({ entity, className }) => {
  const { t } = useTranslation();
  const classes = classNames(className, 'NodeMunicipality', 'NodeMunicipality--teaser');

  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed'], '');
  const logo = entity.getIn(['field_logo', 0, 'url'], '');
  const link = entity.getIn(['paths', DEFAULT_LANGUAGE]);

  return (
    <article className={classes} itemScope itemType="https://schema.org/WebPage">
      <div className="NodeMunicipality--teaser__container container">
        <div>
          <h2>{title}</h2>
          <WysiwygField
            property="schema:text"
            html={body}
          />
          <Button secondary key={link} href={link}>{t('buttons.infoMore')}</Button>
        </div>
        <div>
          <img src={logo} alt="" />
        </div>
      </div>
    </article>
  );
};

export default NodeMunicipality;
